<template>
  <div>
    <carousel>
      <div slot="title">Page not found.</div>
      <div slot="text">Sorry the page you're looking does not exist.</div>
    </carousel>
  </div>
</template>

<script>
import EventBus from '@/event-bus';
import Carousel from '../components/Carousel.vue';

export default {
  components: {
    Carousel,
  },
  mounted() {
    EventBus.$emit('carousel:loaded');
  },
};
</script>

<style lang="scss" scoped>
</style>
